import { type AxiosError } from 'axios';
import { type SWRConfiguration } from 'swr';
import useSWRImmutable from 'swr/immutable';

import { type Customer } from '@app/types/customerCoreData';

import useApiService from './useApiService';

interface Params {
  options?: SWRConfiguration;
}

export function useCustomer({ options }: Params = {}) {
  const { getCustomerCoreData } = useApiService();

  return useSWRImmutable<Customer, AxiosError>(['customer'], getCustomerCoreData, options);
}
